/**
 * Shared sizing for the single "stage" (big player area) of the unified
 * video-editing workspace. Both the composed timeline preview and the
 * source-clip inspector player use the same cap so the stage keeps a stable
 * height when swapping between them. Grows with the viewport, never below
 * the pre-unification 456px cap.
 */
export const STAGE_MAX_HEIGHT = 'max(460px, calc(100vh - 340px))';

// The video player's own height — a fixed value used by BOTH the composed
// timeline preview and the clip inspector's player so switching between clips
// never resizes the player or reflows the page. Shorter than the stage box so
// the inspector's trim controls sit beneath the player.
export const STAGE_PLAYER_HEIGHT = 'max(260px, calc(100vh - 620px))';
